import { DialogInteractOutsideEvent } from '@chakra-ui/react';
import { isToastInteraction } from './isToastInteraction';

/**
 * `onInteractOutside` for a dialog built on `Dialog.Root` directly: closing a
 * toast over it isn't an interaction outside it. `MCenterModal` and `MDrawer`
 * already do this for their callers.
 */
export const keepOpenForToasts = (event: DialogInteractOutsideEvent) => {
  if (isToastInteraction(event)) {
    event.preventDefault();
  }
};
